module.exports = __webpack_public_path__ + "static/media/banana_tarte.4d4807f9.JPG";